import { render } from "./FreePtPromo.vue?vue&type=template&id=0b5e868c&scoped=true"
import script from "./FreePtPromo.vue?vue&type=script&lang=js"
export * from "./FreePtPromo.vue?vue&type=script&lang=js"

import "./FreePtPromo.vue?vue&type=style&index=0&id=0b5e868c&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5e868c"]])

export default __exports__